module.exports = __webpack_public_path__ + "ae3ce13b9aa8cea9bb7e9f7f6ce8d1dd.png";